import { render, staticRenderFns } from "./Psychotechnic.vue?vue&type=template&id=b13de460&"
import script from "./Psychotechnic.vue?vue&type=script&lang=js&"
export * from "./Psychotechnic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports